<template>
    <label class="theme-screen-mode">
        <input v-on:click="check" :checked="isActive" type="checkbox" name="screen">
        <span class="slider-for-screen-mode"></span>Night theme mode</label>
</template>

<script>
    import Cookies from "js-cookie";

    export default {
        data() {
            return {
                isDarkMode: false,
                isActive: false,
            };
        },
        beforeMount() {
            this.isDarkMode = Cookies.get('darkMode');
            if(this.isDarkMode === 'true'){
                this.isActive = true;
            }
        },
        methods: {
            check: function () {
                this.isActive = !this.isActive;
                if (this.isActive) {
                    Cookies.set('darkMode', true, {expires: 360})
                    this.$root.$el.classList.add('dark-mode-screen')
                } else {
                    Cookies.set('darkMode', false, {expires: 360});
                    this.$root.$el.classList.remove('dark-mode-screen')
                }
            }
        }
    }
</script>
